export const Menu = {
    Dashboard: 'MDAS001',
    Usuarios: 'MUSU001',
    Destinos: 'MDES001',
    Proveedores: 'MPRO001',
    Envios: 'MENV001',
    Embarques: 'MEMB001',
    ProveedorDashboard: 'MDAS002',
    ProveedorEnvios: 'MENV002'
}

export const Acciones = {
    Alta_usuario: 'USU001',
    Editar_usuario: 'USU002',
    Editar_perfil_usuario: 'USU003',
    Editar_estatus_usuario: 'USU004',
    Eliminar_usuario: 'USU004',
    Alta_destino: 'DES001',
    Editar_destino: 'DES002',
    Editar_estatus_destino: 'DES003',
    Eliminar_destino: 'DES004',
    Nueva_guía: 'ENV001',
    Recepción_de_guía: 'ENV002',
    Editar_guía: 'ENV003',
    Exportar_información_envío: 'ENV004',
    Ver_detalle_envío: 'ENV005',
    Imprimir_envíos: 'ENV006',
    Alta_embarque: 'EMB001',
    Editar_embarque: 'EMB002',
    Exportar_información_embarque: 'EMB003',
    Actualizar_estatus_embarque: 'EMB004',
    Retroceder_estatus_embarque: 'EMB005',
    Ver_detalle_embarque: 'EMB006',
    Imprimir_embarque: 'EMB007',
    Alta_proveedor: 'PRO001',
    Editar_proveedor: 'PRO002',
    Editar_estatus_proveedor: 'PRO003',
    Enviar_código_de_registro: 'PRO004',
    Eliminar_proveedor: 'PRO005',
    Nuevo_código_proveedor: 'PRO006'
} 